import { useFormik } from "formik";

export const useForm = (initialValues, validationSchema, onSubmit = () => {}) => {
  const {
    isValid,
    values,
    resetForm,
    isSubmitting,
    setSubmitting,
    errors,
    touched,
    setFieldValue,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
    enableReinitialize: true,
    validateOnMount: true,
    validateOnBlur: true,
  });

  return {
    isValid,
    values,
    resetForm,
    isSubmitting,
    setSubmitting,
    errors,
    touched,
    setFieldValue,
    handleChange,
    handleBlur,
    handleSubmit,
  };
};
